if ( document.getElementsByClassName('tabs').length > 0 ){
  [...document.getElementsByClassName('tabs')].forEach( tabsCont => {
    //if no anchor set in url make first tab visible
    if( ! window.location.hash ){
      let firstChildSet = false;
      [...tabsCont.children].forEach( child => {
        if( child.tagName == 'DIV' && ! firstChildSet ){
          firstChildSet = true;
          child.style.display = 'inline-block';
        }
      })
    }
  })
}
